<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1" v-if="about">{{ about.title }}</Title>
          <Title tag="h1" v-else>No encontrado</Title>
          <Content v-if="content" :content="content" />
          <p v-else>No hay contenido disponible</p>
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(subp, index) in abouts" :key="index">
              <router-link
                v-if="!about || about.slug != subp.slug"
                :to="`/acerca-de/${subp.slug}`"
              >
                {{ subp.title }}
              </router-link>
              <span v-else>
                {{ subp.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import programs from "@/data.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content
  },
  setup() {
    const abouts = programs[process.env.VUE_APP_PREFIX].about;
    const route = useRoute().params.about;
    const about = abouts.find(about => about.slug == route);
    const content = about && about.content;

    return {
      about,
      content,
      abouts
    };
  }
};
</script>
